import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/areas/$id')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/tasks/areas/$id', params });
  },
});
